import localforage from 'localforage'

let localforageStoreCrates = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'crates'
})

const initialState = {
  all: [],
  crate: []
}

let state = initialState

const getters = {
  getAllCrates: state => state.all,
  getCrate: state => state.crate
}

const actions = {
  importCrates ({ commit }, crates) {
    return new Promise((resolve, reject) => {
      commit('clearCratesState')
      crates.forEach((crate) => {
        localforageStoreCrates.setItem(String(crate.id), JSON.stringify(crate))
      })
      commit('setCratesToState', crates)
      resolve()
    })
  },
  loadAllCrates ({ commit }) {
    return new Promise((resolve, reject) => {
      var crates = []
      return localforageStoreCrates.iterate(function (value, key, iterationNumber) {
        crates.push(JSON.parse(value))
      }).then(function () {
        commit('setCratesToState', crates)
        resolve()
      })
    })
  },
  clearCratesStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreCrates.clear().then(() => {
        commit('clearCratesState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  setCratesToState (state, crates) {
    state.all = crates
  },
  clearCratesState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/crates.js